import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import poster from '@/static/assets/reviews/RachelGromack_Renters/video.jpg';
import subs from '@/static/assets/reviews/RachelGromack_Renters/subs.vtt';

export const RachelGromack: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Renters, ReviewProduct.All],
  reviewerName: 'Rachel',
  videoUrl: `${ASSETS_URL}/renters/RachelGromack_Renters.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
